import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../component-base';
import { CurrentUserService } from '../../services/current-user.service';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';
import { CommercialRecord, CRInformationByCRNumber } from '../../models/user';
import { CacheService } from '../../services/cashe-service';
import { CompanyUser, EsbSbcGetActiveDelegationsByDelegateeNatIdReq } from '../../models/companyUser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cr-number',
  templateUrl: './cr-number.component.html',
  styleUrls: ['./cr-number.component.css']
})
export class CrNumberComponent extends BaseComponent implements OnInit {
  commercialRecordArr: CommercialRecord[] = [];
  model: CommercialRecord;
  cRInformationByCRNumberArr: CRInformationByCRNumber;


  constructor(private formBuilder: FormBuilder,
    public override currentUserService: CurrentUserService,
    private route: ActivatedRoute,
    public override translate?: TranslateService,
    public router?: Router,

  ) {
    super();
  }


  ngOnInit() {
    this.showLoader = true;
    this.GetCrNumbersOwnershipData();

  }

  GetCrNumbersOwnershipData() {
    const username = CacheService.getUsername();
    this.currentUserService.GetCrNumbersOwnershipData(username).subscribe(result => {
      this.commercialRecordArr = result;
      this.GetActiveDelegationsByDelegateeNatIdReq();
    })
  }

  GetActiveDelegationsByDelegateeNatIdReq() {
    const username = CacheService.getUsername();
    var request = new EsbSbcGetActiveDelegationsByDelegateeNatIdReq();

    request.clientIPAddress = "";
    request.delegateeIdentityNumber = CacheService.getUsername();;
    request.operatorID =0;
    request.lang = CacheService.getCurrentLanguage();
    this.currentUserService.GetActiveDelegationsByDelegateeNatIdReq(request).subscribe(result => {
      result?.listOfDelegations.forEach(e => {
        const crNumber: string = e.services.find(a=>a.id).referenceNumber; // Assign the identity number
        const relationType: string = this.translate.instant("Company.delegator"); // Replace with actual value
        const relationTypeID: string = ("999"); // Replace with actual value
        const crNationalNumber: string = e.delegator.identityNumber; // Replace with actual value
    
        this.commercialRecordArr.push({
            crNumber,
            relationType,
            relationTypeID,
            crNationalNumber
        });
        this.showLoader = false;
    });
    })
  }


  onCommercialRecordChange(event) {
    this.model.crNationalNumber = this.model.crNationalNumber == null?this.model.crNumber :this.model.crNationalNumber;
    CacheService.setCurrentCompany(this.model.crNationalNumber);
    CacheService.setRelationType(this.model.relationType);
    const userId = CacheService.getUserId();
    var companyUser = new CompanyUser();
    companyUser.userId = userId;
    companyUser.crNumber = this.model.crNationalNumber;
    companyUser.relationship = Number(this.model.relationTypeID);
    companyUser.companyProfileRequestId = null;
    companyUser.companyProfileRequest = null;
    this.currentUserService.GetCRInformationByCRNumber(companyUser).subscribe(result => {
      CacheService.setLoginStatus("Active");
      if (!result)
        this.router.navigateByUrl("/");
      else
        this.router.navigateByUrl(`/complete-company/${result.id}`);

    });
  }


}
